import { allRegions, RegionID } from "./regionSelector.data";

export const links = [
  {
    title: "contact.customerService",
    links: [
      {
        text: "contact.title",
        link: "./customer-service/contact-us",
        regions: allRegions,
      },
      {
        text: "faqs.title",
        link: "./customer-service/faqs",
        regions: [RegionID.EU, RegionID.DE, RegionID.Staging],
      },

      {
        text: "faqs.title",
        link: "http://belstaff.zendesk.com/",
        regions: [RegionID.UK, RegionID.US, RegionID.ROW],
        newTab: true,
      },
      {
        text: "delivery.title",
        link: "./customer-service/delivery",
        regions: allRegions,
      },
      {
        text: "returns.title",
        link: "./customer-service/returns",
        regions: allRegions,
      },
      {
        text: "productcare.title",
        link: "./customer-service/product-care",
        regions: allRegions,
      },
      {
        text: "Size Guides",
        link: "./customer-service/size-guide",
        regions: allRegions,
      },
      {
        text: "stockists.title",
        link: "./customer-service/stockists",
        regions: allRegions,
      },
      {
        text: "Circuit Newsletter",
        link: "./signup",
        regions: allRegions,
      },
      {
        text: "circuitMaster.footer",
        link: "./account/circuit-master",
        regions: allRegions,
      },

      {
        text: "Gift Cards",
        link: "./customer-service/gift-cards",
        regions: [RegionID.UK, RegionID.Staging, RegionID.DE],
      },
    ],
  },
  {
    title: "About us",
    links: [
      {
        text: "Our Story",
        link: "./about-us",
        regions: allRegions,
      },
      {
        text: "Brand Responsibility",
        link: "./brand-responsibility",
        regions: allRegions,
      },
      {
        text: "Social Responsibility",
        link: "./social-responsibility",
        regions: allRegions,
      },
      {
        text: "Careers",
        link: "https://careers.belstaff.com/",
        regions: allRegions,
      },
    ],
  },
  {
    title: "Visit us",
    links: [
      {
        text: "stores.title",
        link: "./customer-service/our-stores",
        regions: allRegions,
      },
    ],
  },
  {
    title: "Legal",
    links: [
      {
        text: "TsAndCs.title",
        link: "./legal/terms-and-conditions",
        regions: allRegions,
      },
      {
        text: "privacyPolicy.title",
        link: "./legal/privacy-policy",
        regions: allRegions,
      },
      {
        text: "Cookie Policy",
        link: "./legal/cookie-policy",
        regions: allRegions,
      },
      {
        text: "Modern Slavery Statement",
        link: "./legal/modern-slavery-statement",
        regions: [RegionID.UK, RegionID.Staging],
      },
      {
        text: "Impressum",
        link: "impressum.link",
        regions: [RegionID.DE, RegionID.Staging],
        newTab: true,
      },
      {
        text: "Klarna",
        link: "./legal/klarna",
        regions: [
          RegionID.UK,
          RegionID.US,
          RegionID.Staging,
          RegionID.EU,
          // RegionID.DE,
        ],
      },
      {
        text: "DeclarationOfConformity.title",
        link: "./legal/declaration-of-conformity",
        regions: allRegions,
      },
    ],
  },
];

export const socialMedia = [
  {
    link: "https://www.instagram.com/belstaff/",
    text: "Instagram",
    svg: "M12.002 7.38503C9.44808 7.38503 7.38806 9.4455 7.38806 12C7.38806 14.5545 9.44808 16.615 12.002 16.615C14.5559 16.615 16.616 14.5545 16.616 12C16.616 9.4455 14.5559 7.38503 12.002 7.38503ZM12.002 15.0003C10.3516 15.0003 9.00234 13.6548 9.00234 12C9.00234 10.3452 10.3476 8.99967 12.002 8.99967C13.6564 8.99967 15.0017 10.3452 15.0017 12C15.0017 13.6548 13.6524 15.0003 12.002 15.0003ZM17.8809 7.19625C17.8809 7.79471 17.399 8.27268 16.8047 8.27268C16.2064 8.27268 15.7285 7.79069 15.7285 7.19625C15.7285 6.60181 16.2104 6.11983 16.8047 6.11983C17.399 6.11983 17.8809 6.60181 17.8809 7.19625ZM20.9368 8.28874C20.8685 6.84681 20.5392 5.56956 19.4831 4.51724C18.431 3.46491 17.154 3.13556 15.7124 3.06326C14.2267 2.97891 9.77334 2.97891 8.28756 3.06326C6.84997 3.13154 5.57301 3.46089 4.5169 4.51322C3.46079 5.56555 3.13553 6.8428 3.06325 8.28473C2.97892 9.77084 2.97892 14.2251 3.06325 15.7113C3.13151 17.1532 3.46079 18.4304 4.5169 19.4828C5.57301 20.5351 6.84596 20.8644 8.28756 20.9367C9.77334 21.0211 14.2267 21.0211 15.7124 20.9367C17.154 20.8685 18.431 20.5391 19.4831 19.4828C20.5352 18.4304 20.8645 17.1532 20.9368 15.7113C21.0211 14.2251 21.0211 9.77485 20.9368 8.28874ZM19.0173 17.3058C18.7041 18.093 18.0977 18.6995 17.3066 19.0168C16.122 19.4868 13.3111 19.3783 12.002 19.3783C10.6929 19.3783 7.87797 19.4828 6.69738 19.0168C5.91032 18.7036 5.30396 18.0971 4.98673 17.3058C4.5169 16.1209 4.62532 13.3094 4.62532 12C4.62532 10.6906 4.52091 7.87504 4.98673 6.69419C5.29994 5.90695 5.9063 5.30046 6.69738 4.98315C7.88199 4.51322 10.6929 4.62167 12.002 4.62167C13.3111 4.62167 16.126 4.51724 17.3066 4.98315C18.0937 5.29644 18.7001 5.90293 19.0173 6.69419C19.4871 7.87906 19.3787 10.6906 19.3787 12C19.3787 13.3094 19.4871 16.125 19.0173 17.3058Z",
  },
  {
    link: "https://www.facebook.com/belstaff",
    text: "Facebook",
    svg: "M22.4001 12.0609C22.4001 6.50304 17.9243 2 12.4001 2C6.87595 2 2.40015 6.50304 2.40015 12.0609C2.40015 17.0824 6.057 21.2446 10.8376 22V14.9692H8.29732V12.0609H10.8376V9.84422C10.8376 7.32292 12.3296 5.93022 14.6147 5.93022C15.709 5.93022 16.8534 6.12657 16.8534 6.12657V8.60122H15.5921C14.3501 8.60122 13.9626 9.37688 13.9626 10.1724V12.0609H16.736L16.2925 14.9692H13.9626V22C18.7433 21.2446 22.4001 17.0824 22.4001 12.0609Z",
  },
  {
    link: "https://www.youtube.com/channel/UC8ASz9ZTX5eVyviGl89j2Ww",
    text: "Youtube",
    svg: "M21.5821 7.2003C21.3521 6.33421 20.6744 5.65211 19.8139 5.42063C18.2542 5 12 5 12 5C12 5 5.74586 5 4.18613 5.42063C3.32565 5.65215 2.64794 6.33421 2.41792 7.2003C2 8.77014 2 12.0454 2 12.0454C2 12.0454 2 15.3208 2.41792 16.8906C2.64794 17.7567 3.32565 18.4104 4.18613 18.6419C5.74586 19.0625 12 19.0625 12 19.0625C12 19.0625 18.2541 19.0625 19.8139 18.6419C20.6744 18.4104 21.3521 17.7567 21.5821 16.8906C22 15.3208 22 12.0454 22 12.0454C22 12.0454 22 8.77014 21.5821 7.2003ZM9.95453 15.0192V9.07171L15.1818 12.0455L9.95453 15.0192Z",
  },
  {
    link: "https://www.tiktok.com/@belstaff",
    text: "TikTok",
    svg: "M41,4H9C6.243,4,4,6.243,4,9v32c0,2.757,2.243,5,5,5h32c2.757,0,5-2.243,5-5V9C46,6.243,43.757,4,41,4z M37.006,22.323 c-0.227,0.021-0.457,0.035-0.69,0.035c-2.623,0-4.928-1.349-6.269-3.388c0,5.349,0,11.435,0,11.537c0,4.709-3.818,8.527-8.527,8.527 s-8.527-3.818-8.527-8.527s3.818-8.527,8.527-8.527c0.178,0,0.352,0.016,0.527,0.027v4.202c-0.175-0.021-0.347-0.053-0.527-0.053 c-2.404,0-4.352,1.948-4.352,4.352s1.948,4.352,4.352,4.352s4.527-1.894,4.527-4.298c0-0.095,0.042-19.594,0.042-19.594h4.016 c0.378,3.591,3.277,6.425,6.901,6.685V22.323z",
  },
];
